import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import TrustBar from "../components/TrustBar";
import Trust from "../components/Trust";
import Testimonials from "../components/Testimonials";
import LeadForm from "../components/LeadForm";
import FloridaFacts from "../components/FloridaFacts";
import WhyChoose from "../components/WhyChoose";
import Process from "../components/Process";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";
import StickyMobileCTA from "../components/StickyMobileCTA";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#0F2240] text-white">
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <Trust />
        <Testimonials />
        <LeadForm />
        <FloridaFacts />
        <WhyChoose />
        <Process />
        <FinalCTA />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}
